// extracted by mini-css-extract-plugin
module.exports = {"containerHeader":"styles_containerHeader__2n2V-","overviewHeader":"styles_overviewHeader__qwihO","linkCustomer":"styles_linkCustomer__1lZVW"};